export const SAMPLE = `[
  {
    "external_id": "PLAK-VUL-ECHT-ID-IN",
    "url": "https://www.autoscout24.de/aanbod/... (exacte advertentie-URL)",
    "country": "DE",
    "role": "SOURCE",
    "make": "Porsche",
    "model": "911",
    "generation": "992",
    "variant": "Carrera S",
    "price": 0,
    "mileage_km": 0,
    "first_registration": "JJJJ-MM",
    "fuel": "Benzine",
    "transmission": "Automaat",
    "power_hp": 0,
    "co2_wltp": null,
    "vat_status": "Onbekend",
    "seller_type": "Dealer",
    "city": "",
    "listing_text": "",
    "image_urls": [],
    "equipment": []
  }
]`;

export const EMPTY_FORM = {
  external_id: "",
  url: "",
  country: "DE",
  role: "SOURCE",
  make: "",
  model: "",
  generation: "",
  variant: "",
  price: "",
  mileage_km: "",
  first_registration: "",
  fuel: "Benzine",
  transmission: "Automaat",
  power_hp: "",
  co2_wltp: "",
  vat_status: "Onbekend",
  seller_type: "Dealer",
  city: "",
  seller_name: "",
  colour: "",
  body_type: "",
  vin: "",
  listing_text: "",
  image_urls: "",
  equipment: "",
};
